(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbSortService', [SortService]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbSortService
	 * 
	 * @description
	 * A service that provides sorting functions for the different data types
	 * in the application. The methods in this service are intended to be passed
	 * to an arrays sort function. As a result, all of the methods are pure functions
	 * which do not rely on `this`.
	 */
	function SortService() {

		return {

			/**
			 * @ngdoc method
			 * @name smbSortService.sortObjectStringByProperty
			 * @methodOf smb-app.smbSortService
			 * @kind function
			 * 
			 * @description
			 * Creates and returns a function that can be to sort an array of
			 * objects by a specific string property.
			 * 
			 * @param {String} propertyName The name of the property the objects should
			 * be sorted by
			 * 
			 * @returns {Function} A function that can be used in array's sort method to
			 * sort objects by a specific property anem
			 */
			sortObjectByStringProperty: sortObjectByStringProperty,

			sortObjectByDateProperty: sortObjectByDateProperty,

			sortDate: sortDate,

			sortByString: sortByString
		};

		function sortObjectByStringProperty(propertyName, direction) {
			return function (obj1, obj2) {
				return sortByString(obj1[propertyName], obj2[propertyName], direction);
			};
		}

		function sortByString(string1, string2, direction) {
			if (direction) {
				return string1.toLowerCase().localeCompare(string2.toLowerCase());
			}
			else {
				return string2.toLowerCase().localeCompare(string1.toLowerCase());
			}
		}

		function sortObjectByDateProperty(propertyName) {
			return function(obj1, obj2) {
				return sortDate(obj1[propertyName], obj2[propertyName]);
			};
		}

		function sortDate(date1, date2) {
			var y1 = date1.getFullYear();
			var m1 = date1.getMonth();
			var d1 = date1.getDate();

			var y2 = date2.getFullYear();
			var m2 = date2.getMonth();
			var d2 = date2.getDate();

			if (y1 < y2) {
				return 1;
			} else if (y1 > y2) {
				return -1;
			} else if (m1 < m2) {
				return 1;
			} else if (m1 > m2) {
				return -1;
			} else if (d1 < d2) {
				return 1;
			} else if (d1 > d2) {
				return -1;
			} else {
				return 0;
			}
		}
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/services/sortService.js
// module id = 158
// module chunks = 1